export default "__VITE_ASSET__CzVL10aB__"